import { Link, useParams } from 'react-router-dom';
import { Button } from '@mui/material';

import { ResourceExplorerSection } from '../components/resource-explorer-section';
import { LoadingState } from '../components/loading-state';
import { useGetProviderInfoQuery } from '../store/api';

/**
 * Member-scoped Resource Explorer.
 *
 * The same explorer the organization page hosts, pinned to one member: every
 * list is a list-for-user for this provider, so the catalog only offers types
 * the backend can list that way (types without the canonical user-list
 * contract would 400 `list_not_supported`).
 */
export default function ProviderResourcesPage() {
  const { providerId: urlProviderId } = useParams<{ providerId: string }>();
  const providerId = urlProviderId ? decodeURIComponent(urlProviderId) : null;

  const { data: provider, isLoading } = useGetProviderInfoQuery(
    { providerId: providerId ?? '' },
    { skip: !providerId },
  );

  if (isLoading) {
    return <LoadingState message="Loading resources..." />;
  }

  if (!providerId || !provider) {
    return (
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900">Provider not found</h2>
        <Link to="/admin-v2">
          <Button className="mt-4">Back to Search</Button>
        </Link>
      </div>
    );
  }

  return (
    <ResourceExplorerSection
      organizationId={provider.organization_id ?? ''}
      lockedProviderId={providerId}
    />
  );
}
